import apiService from '../utils/apiService';

import {
  GET_SIGNET_LIST,
  GET_SIGNET_LIST_START,
  GET_SIGNET_LIST_ERROR,
  GET_SIGNET_LIST_FILTER,
  GET_SIGNET_LIST_FILTER_START,
  GET_SIGNET_LIST_FILTER_ERROR,
  UPDATE_SIGNET_STATUS,
  UPDATE_SIGNET_STATUS_START,
  UPDATE_SIGNET_STATUS_ERROR,
  GET_SIGNET,
  GET_SIGNET_START,
  GET_SIGNET_ERROR,
  DOWNLOAD_SIGNET_ATTACHMENT_START,
  DOWNLOAD_SIGNET_ATTACHMENT_ERROR,
  GET_SIGNET_BY_CLIENT_LIST,
  GET_SIGNET_BY_CLIENT_LIST_START,
  GET_SIGNET_BY_CLIENT_LIST_ERROR,
} from './types';

import {
  signetFindAllPageablePath,
  filterPageablePath,
  signetUpdateStatusPath,
  signetFindByIdStatusPath,
  signetUpdateStatePath,
  signetAttachmentDownloadPath,
  signetFindAllByClientPath,
} from '../constants/apiEndpoints';

import { notificationTypeSuccess, signetStatuses } from '../constants/globals';
import { createNotification } from '../utils';

const getSignetListStart = () => {
  return {
    type: GET_SIGNET_LIST_START,
  };
};
const getSignetListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_SIGNET_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getSignetListUnsuccessfully = (err) => {
  return {
    type: GET_SIGNET_LIST_ERROR,
    payload: err,
  };
};

const getSignetFilterListStart = () => {
  return {
    type: GET_SIGNET_LIST_FILTER_START,
  };
};
const getSignetFilterListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_SIGNET_LIST_FILTER,
    payload: [data, pageNumber, totalElements],
  };
};
const getSignetFilterListUnsuccessfully = (err) => {
  return {
    type: GET_SIGNET_LIST_FILTER_ERROR,
    payload: err,
  };
};

const updateSignetStatusStart = () => {
  return {
    type: UPDATE_SIGNET_STATUS_START,
  };
};
const updateSignetStatusSuccessfully = (data) => {
  return {
    type: UPDATE_SIGNET_STATUS,
    payload: data,
  };
};
const updateSignetStatusUnsuccessfully = (err) => {
  return {
    type: UPDATE_SIGNET_STATUS_ERROR,
    payload: err,
  };
};

const getSignetStart = () => {
  return {
    type: GET_SIGNET_START,
  };
};
const getSignetSuccessfully = (data) => {
  return {
    type: GET_SIGNET,
    payload: data,
  };
};
const getSignetUnsuccessfully = (err) => {
  return {
    type: GET_SIGNET_ERROR,
    payload: err,
  };
};

const downloadSignetAttachmentStart = () => {
  return {
    type: DOWNLOAD_SIGNET_ATTACHMENT_START,
  };
};
const downloadSignetAttachmentSuccessfully = (data, documentName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', documentName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(url);
};
const downloadSignetAttachmentUnsuccessfully = (err) => {
  return {
    type: DOWNLOAD_SIGNET_ATTACHMENT_ERROR,
    payload: err,
  };
};

const getSignetByClientListStart = () => {
  return {
    type: GET_SIGNET_BY_CLIENT_LIST_START,
  };
};

const getSignetByClientListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_SIGNET_BY_CLIENT_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getSignetByClientListUnsuccessfully = (err) => {
  return {
    type: GET_SIGNET_BY_CLIENT_LIST_ERROR,
    payload: err,
  };
};

export const findAllSignetPageable = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getSignetListStart());
    return apiService
      .get(signetFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getSignetListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getSignetListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllSignetFilterPageable = (
  pageNumber,
  pageSize,
  data,
  succesCallback
) => {
  return (dispatch) => {
    dispatch(getSignetFilterListStart());
    return apiService
      .post(filterPageablePath(pageNumber, pageSize), data)
      .then((response) => {
        dispatch(
          getSignetFilterListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
        succesCallback();
      })
      .catch((err) => {
        dispatch(getSignetFilterListUnsuccessfully(err?.response?.data));
      });
  };
};

export const updateSignetStatus = (signetId, statusName, callback, message) => {
  return (dispatch) => {
    dispatch(updateSignetStatusStart());
    return apiService
      .put(signetUpdateStatusPath(signetId, statusName))
      .then((response) => {
        dispatch(updateSignetStatusSuccessfully(response.data));
        callback();
        statusName === signetStatuses.APPROVED.name &&
          createNotification(
            notificationTypeSuccess,
            message.signet,
            message.successAcceptSignet
          );
        statusName === signetStatuses.FINISHED.name &&
          createNotification(
            notificationTypeSuccess,
            message.signet,
            message.successAcceptSignet
          );
        statusName === signetStatuses.COMPLEMENTED.name &&
          createNotification(
            notificationTypeSuccess,
            message.complementSignet,
            message.successComplementedSubmission
          );
      })
      .catch((err) => {
        dispatch(updateSignetStatusUnsuccessfully(err?.response?.data));
      });
  };
};

export const updateSignetState = (id, signetState, callback) => {
  return (dispatch) => {
    dispatch(updateSignetStatusStart());
    return apiService
      .patch(signetUpdateStatePath(id, signetState))
      .then((response) => {
        dispatch(updateSignetStatusSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(updateSignetStatusUnsuccessfully(err?.response?.data));
      });
  };
};

export const findSignetById = (id) => {
  return (dispatch) => {
    dispatch(getSignetStart());
    return apiService
      .get(signetFindByIdStatusPath(id))
      .then((response) => {
        dispatch(getSignetSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getSignetUnsuccessfully(err?.response?.data));
      });
  };
};

export const downloadAttachment =
  (uuidDocName, documentName) => async (dispatch) => {
    dispatch(downloadSignetAttachmentStart());
    return apiService
      .getFromFile(signetAttachmentDownloadPath(uuidDocName))
      .then((response) => {
        dispatch(
          downloadSignetAttachmentSuccessfully(response.data, documentName)
        );
      })
      .catch((err) => {
        dispatch(downloadSignetAttachmentUnsuccessfully(err?.response?.data));
      });
  };

export const findAllSignetsByClient = (userId, pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getSignetByClientListStart());
    return apiService
      .get(signetFindAllByClientPath(userId, pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getSignetByClientListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getSignetByClientListUnsuccessfully(err?.response?.data));
      });
  };
};
